import type { AppConfig } from '@tandemone/types'

import { api } from './client'

export type { AppConfig, AppEnv } from '@tandemone/types'

let cached: AppConfig | null = null

/**
 * synchronous accessor for code paths that run AFTER initObservability
 * main.tsx awaits getConfig() before mounting so this is always populated
 * by the time components render.
 */
export function getCachedConfig(): AppConfig | null {
  return cached
}

export async function getConfig(): Promise<AppConfig> {
  if (cached) return cached
  try {
    const { data } = await api.get<AppConfig>('/v1/config')
    cached = data
    return data
  } catch {
    return {
      sentryDsn: null,
      googlePlacesApiKey: null,
      googleMapsMapId: null,
      turnstileSiteKey: null,
      appEnv: 'dev',
      appVersion: 'dev',
      billingEnabled: false,
      pwaEnabled: false
    }
  }
}

export function isBillingEnabled(): boolean {
  return cached?.billingEnabled ?? false
}

export function isPwaEnabled(): boolean {
  return cached?.pwaEnabled ?? false
}
